export const Colors = {
  primary: 'rgb(0,162,97)',
};
